export default class FailedToReconnectSockets extends Error {
  name = 'FailedToReconnectSockets';

  constructor(attempts) {
    super(`Failed to reconnect sockets after ${attempts} attempts`);
  }
}
